import { useState, useEffect } from 'react';

const useDetectVirtualKeyboard = () => {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    /**
     * Guard virtual keyboard detection to only browser environments with visualViewport
     */
    if (typeof window !== 'undefined' && 'visualViewport' in window && window.visualViewport) {
      let recentlyFocused = false;
      let recentlyResized = false;
      let recentlyFocusedTimeout = null;
      let recentlyResizedTimeout = null;
      const validFocusableElements = ['INPUT', 'TEXTAREA'];
      const expireRecentlyFocused = () => {
        recentlyFocused = false;
      };
      const expireRecentlyResized = () => {
        recentlyResized = false;
      };
      const checkVirtualKeyboardOpen = () => {
        setIsKeyboardVisible(false);
        if (recentlyFocused && recentlyResized) {
          setIsKeyboardVisible(true);
        }
      };
      const resizeHandler = () => {
        if (recentlyResizedTimeout !== null) {
          window.clearTimeout(recentlyResizedTimeout);
          recentlyResizedTimeout = null;
        }
        recentlyResized = true;
        recentlyResizedTimeout = window.setTimeout(expireRecentlyResized, 500);
        checkVirtualKeyboardOpen();
      };
      const elementFocusHandler = event => {
        if (recentlyFocusedTimeout !== null) {
          window.clearTimeout(recentlyFocusedTimeout);
          recentlyFocusedTimeout = null;
        }
        recentlyFocused = true;
        recentlyFocusedTimeout = window.setTimeout(expireRecentlyFocused, 500);
        checkVirtualKeyboardOpen();
      };
      const documentFocusHandler = event => {
        if (event.target && typeof event.target !== 'undefined' && event.target instanceof HTMLElement && event.target.nodeName && typeof event.target.nodeName !== 'undefined') {
          if (validFocusableElements.indexOf(event.target.nodeName) !== -1) {
            elementFocusHandler();
          }
        }
      };
      document.addEventListener('focus', documentFocusHandler, true);
      window.visualViewport.addEventListener('resize', resizeHandler);
      return () => {
        document.removeEventListener('focus', documentFocusHandler, true);
        if (typeof window !== 'undefined' && 'visualViewport' in window && window.visualViewport) {
          window.visualViewport.removeEventListener('resize', resizeHandler);
        }
      };
    }
  }, []);
  return [isKeyboardVisible];
};

export { useDetectVirtualKeyboard as u };
//# sourceMappingURL=useDetectVirtualKeyboard-XkMJ_5y1-XkMJ_5y1.js.map
